import { slideToggle, slideUp } from '../components/modules/dom-interactions';
import throttle from '../components/modules/throttle';

const menu = '.js-sticky-inline-menu';
const stickyClass = 'sticky-menu--pinned';

/**
 *
 * @param {string} hash
 */
function updateActiveLink(hash) {
  const value = (hash[0] === '#') ? hash.slice(1) : hash;
  const target = document.querySelector(`.js-sticky-menu-link[data-bs-target="${hash}"]`);

  if (target) {
    document.querySelectorAll('.js-sticky-menu-link').forEach((el) => {
      el.classList.remove('active');
    });
    target.classList.add('active');
    target.closest('.sticky-menu__mobile-nav').querySelector('.js-open-sticky-nav').innerText = value.charAt(0).toUpperCase() + value.slice(1);
  }
}

document.addEventListener('DOMContentLoaded', (event) => {
  const el = document.querySelector(menu);

  if (el) {
    const observer = new IntersectionObserver(
      ([e]) => {
        const rootTop = e.rootBounds ? e.rootBounds.top : 26;
        const isAboveRoot = e.boundingClientRect.top < rootTop;

        el.classList.toggle(stickyClass, e.intersectionRatio < 1 && isAboveRoot);
      },
      {
        rootMargin: '-26px 0px 0px 0px',
        threshold: [1],
      },
    );

    observer.observe(el);

    import('bootstrap/js/src/scrollspy').then((module) => {
      const ScrollSpy = module.default;

      const spy = new ScrollSpy(document.body, {
        target: '.js-sticky-inline-scrollspy',
        offset: 50,
      });

      if (global.breakpoints.desktop > window.innerWidth) {
        window.addEventListener('activate.bs.scrollspy', (event) => {
          updateActiveLink(event.relatedTarget);
        });
      }
    });
  }

  document.querySelectorAll('.js-open-sticky-nav').forEach((el) => {
    ['click', 'keyup'].forEach((e) => {
      el.addEventListener(e, (event) => {
        if (event.type === 'click' || (event.type === 'keyup' && ([40, 32].includes(event.keyCode)))) {
          const sibling = event.currentTarget.nextElementSibling;

          document.querySelectorAll('.js-sticky-nav-dropdown.active').forEach((activeEl) => {
            slideToggle(activeEl, 400);
          });

          slideToggle(sibling, 400);
        }
      });
    });
  });

  document.querySelectorAll('.js-sticky-menu-link').forEach((el) => {
    el.addEventListener('click', (event) => {
      updateActiveLink(event.currentTarget.getAttribute('data-bs-target'));
      slideUp(event.currentTarget.closest('.js-sticky-nav-dropdown'), 400);
    });
  });

  window.addEventListener('scroll', throttle(() => {
    document.querySelectorAll('.js-sticky-nav-dropdown.active').forEach((activeEl) => {
      slideToggle(activeEl, 400);
    });
  }, 100));
});
